import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import TestimonialSection from "../../components/TestimonialSection/TestimonialSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import PreviousSummitsSection from "../../components/PreviousSummitsSection/PreviousSummitsSection";


const TestimonialsPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>
          Cash Flow Course for Business Owners | Cash Flow Summit
        </title>
        <meta
          name="description"
          content="Cash Flow Summit by Jagmohan Singh offers a practical cash flow course for business owners to master financial control, increase revenue streams, and create a stronger, more profitable business."
        />
        <meta
          name="keywords"
          content="Cash Flow Course for Business Owners, Cash Flow Summit"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Testimonial"} pagesub={"Testimonial"} />
      <TestimonialSection />
      <PreviousSummitsSection />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default TestimonialsPage;
